<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="0"
      :label="translation(translationList.vehicle_manufacture_year, 'An fabricație')"
      :items="years"
      name="manufacture_year"
      item-title="year"
      item-value="year"
      v-model="selectedYear"
      :rules="[v => !!v || translation(translationList.required, 'Acest camp este obligatoriu')]"
  >
    <template v-slot:append-inner>
      <v-tooltip location="top" open-delay="500" open-on-click open-on-hover>
        <template v-slot:activator="{ props }">
           <v-icon v-bind="props" class="cursor-pointer" aria-label="info">
            mdi-information
          </v-icon>
        </template>
        <span>
          <NuxtImg
              src="/images/vehicle/registration_template/template_b.png"
              class="h-100"
              loading="lazy"
              alt="Registration template"
          />
        </span>
      </v-tooltip>
    </template>
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, toRefs } from 'vue';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Number as () => number | null,
      default: null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-vehicle-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const selectedYear = ref<number | null>(modelValue.value);
    const years = ref<{ year: number }[]>([]);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref<string[]>([]);

    const getYears = () => {
      const currentYear = new Date().getFullYear();
      for (let year = currentYear; year >= currentYear - 100; year--) {
        years.value.push({ year });
      }
    };

    onMounted(async () => {
      getYears();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = !!selectedYear.value;
      emit('validation-vehicle-status', { field: 'manufacture_year', isValid });

      // Listen for validate event
      window.addEventListener('validate-vehicle', (data) => {
        if (data.detail && data.detail === 'manufacture_year') {
          if (!selectedYear.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-vehicle-status', { field: 'manufacture_year', isValid: true });
          }
        }
      });
    });

    watch(selectedYear, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(modelValue, (newValue) => {
      selectedYear.value = newValue;
      error.value = [];
      const isValid = !!newValue;
      emit('validation-vehicle-status', { field: 'manufacture_year', isValid });
    });

    return {
      selectedYear,
      translationList,
      translation,
      years,
      error,
    };
  },
});
</script>
